import BaseSpinWrapper from 'components/atoms/base-spin-wrapper';
import { useTranslation } from 'react-i18next';

import InsuranceTypeChart from './components/insurance-type-chart';
import FulfillmentTypeChart from './components/fulfillment-type-chart';
import s from './styles.module.scss';

import type { StatusBlocks } from './hooks/use-fulfillment-data';
import type { ModuleType } from 'infrastructure/enums';
import type {
  ICcmPatientsByInsurances,
  IRpmPatientsByInsurances,
} from 'infrastructure/interfaces';
import type { FC } from 'react';

interface OnboardingStatusGraphsProps {
  loading: boolean;
  statusBlocks?: StatusBlocks;
  insuranceBlocks: ICcmPatientsByInsurances[] | IRpmPatientsByInsurances[];
  module: ModuleType;
}

const OnboardingStatusGraphs: FC<OnboardingStatusGraphsProps> = ({
  statusBlocks,
  insuranceBlocks,
  loading,
  module,
}) => {
  const { t } = useTranslation();

  return (
    <BaseSpinWrapper spinning={loading}>
      <div className={s['graph-wrapper']}>
        <div className={s['graph-item']}>
          <h4>{t('labels.insuranceChart')}</h4>
          <InsuranceTypeChart insuranceBlocks={insuranceBlocks} />
        </div>
        <div className={s['graph-item']}>
          <h4>{t('labels.statusChart')}</h4>
          <FulfillmentTypeChart statusBlocks={statusBlocks} module={module} />
        </div>
      </div>
    </BaseSpinWrapper>
  );
};

export default OnboardingStatusGraphs;
